module.exports = __webpack_public_path__ + "img/pairui.c1edab2d.jpg";